import { AlertTriangle, Clock } from "lucide-react";

const rating = (v) => (/^\d+$/.test((v || "").trim()) ? parseInt(v, 10) : null);

const spotsText = (row) => {
  if (!row || row.spots_left == null) return "";
  return row.spots_left > 0 ? `${row.spots_left} left` : "Full · waitlist";
};

// Required division choice in the sign-up form, with per-division spots and a Fargo limit warning.
export function DivisionPicker({ divisions, info, value, onChange, fargo }) {
  const sel = info[value];
  const r = rating(fargo);
  const over = sel?.fargo_max > 0 && r != null && r > sel.fargo_max;
  const full = sel?.spots_left === 0;
  return (
    <fieldset data-testid="signup-division">
      <legend className="block text-sm font-medium text-[#333333] mb-1.5">Division <span className="text-[#E11D2A]">*</span></legend>
      <div className="flex flex-wrap gap-2">
        {divisions.map((d) => {
          const row = info[d];
          const active = value === d;
          return (
            <button
              key={d}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onChange(d)}
              data-testid={`signup-division-${d}`}
              className={`rounded-xl border px-3.5 py-1.5 text-left transition-colors ${
                active ? "bg-[#1E63C4] border-[#1E63C4] text-white" : "border-[#E5E7EB] text-[#333333] hover:border-[#1E63C4]"
              }`}
            >
              <span className="block text-sm font-semibold">{d}</span>
              {(row?.fargo_max > 0 || spotsText(row)) && (
                <span className={`block text-[11px] ${active ? "text-white/85" : "text-[#777777]"}`} data-testid={`signup-division-meta-${d}`}>
                  {[row?.fargo_max > 0 ? `Fargo ${row.fargo_max} max` : "", spotsText(row)].filter(Boolean).join(" · ")}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {full && (
        <p className="mt-2 flex items-start gap-1.5 text-xs text-[#1E63C4]" data-testid="signup-division-full">
          <Clock className="h-3.5 w-3.5 mt-0.5 shrink-0" /> {value} is full. You'll go on its waiting list, or pick another division with spots left.
        </p>
      )}
      {over && (
        <p className="mt-2 flex items-start gap-1.5 rounded-md bg-amber-50 border border-amber-200 px-2.5 py-2 text-xs text-amber-900" data-testid="signup-fargo-warning">
          <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" />
          Your FargoRate ({r}) is above the {sel.fargo_max} limit for {value}. You can still sign up, but the organizer may move or decline your registration.
        </p>
      )}
    </fieldset>
  );
}
